module.exports = __webpack_public_path__ + "img/pr_8.a21e68f6.png";